import { render, staticRenderFns } from "./addGoodsSkill.vue?vue&type=template&id=31180a5e&scoped=true&"
import script from "./addGoodsSkill.vue?vue&type=script&lang=js&"
export * from "./addGoodsSkill.vue?vue&type=script&lang=js&"
import style0 from "./addGoodsSkill.vue?vue&type=style&index=0&id=31180a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31180a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31180a5e')) {
      api.createRecord('31180a5e', component.options)
    } else {
      api.reload('31180a5e', component.options)
    }
    module.hot.accept("./addGoodsSkill.vue?vue&type=template&id=31180a5e&scoped=true&", function () {
      api.rerender('31180a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subject/rightTool/addGoodsSkill.vue"
export default component.exports